// extracted by mini-css-extract-plugin
export default {"sendForm":"MessageSender_sendForm__01EP9","textarea":"MessageSender_textarea__snabn","button":"MessageSender_button__YFQVu"};